import initializer from '@/lib/initializer'
import lazyModule from '@/lib/lazy-module'
import 'vite/modulepreload-polyfill'
import { initDisclosureWidgets } from '@/lib/a11y'
import revive from '@/lib/revive.js'
import { initTabKeyListener } from '@/lib/accessibility'
import { initBluecore } from '@/lib/bluecore'
import scrollAnimation from '@/lib/scroll-animation'
import sal from 'sal.js'

const islands = import.meta.glob('@/islands/**.js')
const summaries = document.querySelectorAll('[id^="Details-"] summary')

revive(islands)
initDisclosureWidgets(summaries)

if (window.decodeURI(window.location.pathname) === '/account/addresses') {
  import('@/lib/shopify_common')
  import('@/lib/customer-address')
}

import picture from '../../modules/picture/picture'
import productCard from '../../modules/product-card/product-card-mixin'
import carouselSwiper from '../../modules/carousel-swiper/carousel-swiper'
import header from '../../modules/header/header'
import footer from '../../modules/footer/footer'
import promobar from '../../modules/promobar/promobar'
import hero from '../../modules/hero/hero'
import heroShort from '../../modules/hero-short/hero-short'
import marquee from '../../modules/marquee/marquee'
import contentCarousel from '../../modules/content-carousel/content-carousel'
import featuredProduct from '../../modules/featured-product/featured-product'
import productCarousel from '../../modules/product-carousel/product-carousel'
import splitScroller from '../../modules/split-scroller/split-scroller'
import videoEmbed from '../../modules/video-embed/video-embed'
import fullWidth from '../../modules/full-width/full-width'
import twoImage from '../../modules/two-image/two-image'
import media from '../../modules/media/media'
import featuredIngredient from '../../modules/featured-ingredient/featured-ingredient'
import faqs from '../../modules/faqs/faqs'
import accordions from '../../modules/accordions/accordions'
import blockQuote from '../../modules/block-quote/block-quote'
import blockQuoteOutline from '../../modules/block-quote-outline/block-quote-outline'
import cartGrid from '../../modules/cart-grid/cart-grid'
import miniCart from '../../modules/mini-cart/mini-cart'
import contactForm from '../../modules/contact-form/contact-form'
import emailCollection from '../../modules/email-collection/email-collection'
const newsletterForm = lazyModule('newsletterForm', { offset: 120 })

document.addEventListener('DOMContentLoaded', () => {
  initializer({
    picture,
    productCard,
    carouselSwiper,
    promobar,
    header,
    hero,
    heroShort,
    marquee,
    contentCarousel,
    featuredProduct,
    productCarousel,
    splitScroller,
    videoEmbed,
    fullWidth,
    twoImage,
    media,
    featuredIngredient,
    faqs,
    accordions,
    blockQuote,
    blockQuoteOutline,
    cartGrid,
    miniCart,
    footer,
    emailCollection,
    newsletterForm,
    contactForm
  })

  initTabKeyListener()
  scrollAnimation()
  initBluecore()
  // Do not remove "window.scrollAnimations" because it's currently used in multiple places
  window.scrollAnimations = sal({
    threshold: 0.1,
  })
})